import { createReducer } from "@reduxjs/toolkit";
import { hydrateApplicationUser } from "../../authentication/hydrateApplicationUser";
import { getAuthenticationSession } from "../actions/authentication";
import { submitAwsMarketplaceActivation } from "../actions/awsmarketplace";
import { createSubscription, createTrial } from "../actions/licenses";
import {
    getUserLicenseInfo,
    logIn,
    logOut,
    setRemainingUnits,
    type IUserLicenseInfoResponse,
} from "../actions/user";
import { IUserState } from "../types/IUserState";

const getDefaultState = (): IUserState => ({ csrf_token: null });

export const user = createReducer(getDefaultState(), (builder) => {
    builder.addCase(logIn.success, (state, action) =>
        getNewUser(action.payload)
    );
    builder.addCase(getAuthenticationSession.success, (state, action) =>
        hydrateApplicationUser(action.payload)
    );
    builder.addCase(logOut.success, () => getNewUser());
    builder.addCase(createTrial.success, (state, action) =>
        mergeUser(state, action.payload.user)
    );
    builder.addCase(createSubscription.success, (state, action) =>
        mergeUser(state, action.payload.user)
    );
    builder.addCase(submitAwsMarketplaceActivation.success, (state, action) => {
        if (action.payload.success)
            return mergeUser(state, action.payload.user);
    });
    builder.addCase(
        getUserLicenseInfo.success,
        (state, action: { payload: IUserLicenseInfoResponse }) => {
            state.units = action.payload.units_remaining;
        }
    );
    builder.addCase(setRemainingUnits, (state, action) => {
        state.units = action.payload;
    });
});

const getNewUser = (response = undefined): IUserState =>
    response
        ? response
        : {
              csrf_token: "",
              units: 0,
              socket_token: "",
              userName: "",
              isLicensedForEstimation: false,
          };

const mergeUser = (state, response): IUserState => {
    const restProps = { ...response };
    delete restProps.csrf_token;
    delete restProps.socket_token;
    delete restProps.validation_token;
    return { ...state, ...restProps };
};
